import React from "react";
import { Box } from "@mui/material";
import TipAnimation from "./index";

/**
 * Renders concurrent tip animations as a vertical stack above the stream
 * controls. Each TipAnimation used to be absolutely positioned at the same
 * spot, so two tips in the same second drew on top of each other.
 */
export default function TipAnimationStack({ tips, onComplete }) {
  if (!tips || tips.length === 0) return null;
  return (
    <Box className="tip-animation-stack" aria-live="polite">
      {tips.map((tip) => (
        <TipAnimation
          key={tip.id}
          username={tip.username}
          amount={tip.amount}
          currency={tip.currency}
          profileImg={tip.profileImg}
          onComplete={() => onComplete(tip.id)}
        />
      ))}
    </Box>
  );
}
